<template>
  <div class="back" @click="back" v-show="!noBack">
    <van-icon name="arrow-left" />
    <div>{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'back',
  data() {
    return {
      noBack: false
    }
  },
  props: {
    title: {
      type: String,
      default: '返回'
    }
  },
  created() {
    const noBack = localStorage.getItem('noBack')
    if (noBack) {
      this.noBack = JSON.parse(localStorage.getItem('noBack'))
    } else {
      this.noBack = false
    }
  },
  methods: {
    back() {
      console.log(window.history)
      console.log(sessionStorage.getItem('backPath'))
      this.$router.push(sessionStorage.getItem('backPath'))
      // if (window.history.length > 1) {
      //   this.$router.go(-1)
      // } else {
      //   this.$router.push('/home')
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.back {
  position: fixed;
  left: 0;
  bottom: 120px;
  width: 60px;
  height: 30px;
  padding-right: 10px;
  background-color: #3b8bff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 0 20px 20px 0;
  font-size: 14px;
  color: #fff;
}
</style>
